import { gql } from "@apollo/client";

const WEBHOOK_DELIVERY_FIELDS = gql`
  fragment WebhookDeliveryFields on WebhookDelivery {
    id
    webhookEndpointId
    eventId
    eventType
    trigger
    status
    statusReason
    attemptCount
    nextAttemptAt
    completedAt
    createdAt
    attempts {
      attemptNumber
      startedAt
      durationMs
      outcome
      statusCode
      responseExcerpt
      errorCode
    }
  }
`;

export const GET_PLATFORM_WEBHOOK_ENDPOINTS = gql`
  query platformWebhookEndpoints($selectedCompanyId: ID) {
    platformWebhookEndpoints(selectedCompanyId: $selectedCompanyId) {
      id
      url
      status
    }
  }
`;

export const GET_PLATFORM_WEBHOOK_DELIVERIES = gql`
  ${WEBHOOK_DELIVERY_FIELDS}
  query platformWebhookDeliveries(
    $selectedCompanyId: ID
    $eventId: ID
    $resourceId: ID
    $startDate: Float
    $endDate: Float
    $webhookEndpointId: ID!
    $first: Int
    $after: String
  ) {
    platformWebhookDeliveries(
      selectedCompanyId: $selectedCompanyId
      eventId: $eventId
      resourceId: $resourceId
      startDate: $startDate
      endDate: $endDate
      webhookEndpointId: $webhookEndpointId
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          ...WebhookDeliveryFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const REPLAY_PLATFORM_WEBHOOK_EVENT = gql`
  ${WEBHOOK_DELIVERY_FIELDS}
  mutation replayPlatformWebhookEvent(
    $webhookEndpointId: ID!
    $eventId: ID!
    $selectedCompanyId: ID
  ) {
    replayPlatformWebhookEvent(
      selectedCompanyId: $selectedCompanyId
      webhookEndpointId: $webhookEndpointId
      eventId: $eventId
    ) {
      ...WebhookDeliveryFields
    }
  }
`;
